export const FILTER_TYPE_DIGITAL_CONTENT = 10
export const FILTER_TYPE_PENDING_REVIEW = 11
export const TYPE = 5
export const REASON_ORDER_CANCELATION = 36
